import {useAuthStore} from '@/store/auth-store';
import {sessionScope} from '@/features/auth/session-scope';
import { create } from 'zustand';

/**
 * Shadow-mode Inbox Agent suggestions are tenant-wide Socket.IO events, not
 * customer messages. Keep them ephemeral and separate from Ashley Copilot's
 * suggestion store so their provenance remains explicit in the chat UI.
 */
export interface InboxAgentSuggestion {
  conversationId: string;
  suggestion: string;
  createdAt?: string;
}

interface InboxAgentSuggestionState {
  byConversation: Record<string, InboxAgentSuggestion>;
  setSuggestion: (suggestion: InboxAgentSuggestion) => void;
  clearSuggestion: (conversationId: string, expected?: InboxAgentSuggestion) => void;
}

export const useInboxAgentSuggestionStore = create<InboxAgentSuggestionState>((set) => ({
  byConversation: {},
  setSuggestion: (suggestion) =>
    set((state) => ({
      byConversation: { ...state.byConversation, [suggestion.conversationId]: suggestion },
    })),
  clearSuggestion: (conversationId,expected) =>
    set((state) => {
      if (!state.byConversation[conversationId] || expected && state.byConversation[conversationId] !== expected) return {};
      const byConversation = { ...state.byConversation };
      delete byConversation[conversationId];
      return { byConversation };
    }),
}));

export function useInboxAgentSuggestionFor(
  conversationId: string | null | undefined,
): InboxAgentSuggestion | null {
  return useInboxAgentSuggestionStore((state) =>
    conversationId ? state.byConversation[conversationId] ?? null : null,
  );
}

useAuthStore.subscribe((next,previous)=>{if(sessionScope(next)!==sessionScope(previous))useInboxAgentSuggestionStore.setState({byConversation:{}});});
